import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { locales } from './locales.js'

Vue.use(VueI18n);

export default new VueI18n({
  locale: localStorage.getItem('locale') ?? 'id',
  messages: locales,
});